import { useApi } from '@/features/api/useAPI'
import { useNotificationsStore } from '@/features/notifications/useNotificationsStore'
import type { Preferences } from '@/features/preferences/types'
import { useTelemetry } from '@/features/telemetry/useTelemetry'

export async function updatePreferences(preferences: Preferences) {
	const { notifyError } = useNotificationsStore()
	const { trackException } = useTelemetry()
	const { apiPost } = useApi()

	try {
		const { data } = await apiPost<Partial<Preferences>>(`/events/preferences`, preferences)

		return data
	} catch (e) {
		trackException(e as Error, 'Failed to update user preferences.')

		notifyError('Failed to update user preferences.')
	}
}

export async function getPreferences() {
	const { notifyError } = useNotificationsStore()
	const { trackException } = useTelemetry()
	const { apiGet } = useApi()

	try {
		const { data } = await apiGet<Preferences>('/events/preferences')

		return data
	} catch (e) {
		trackException(e as Error, 'Failed to load user preferences.')

		notifyError('Failed to load user preferences.')
	}
}
